import _ from "lodash";
import { Filter, Where } from "../entityTable/Filter";
import { BaseColumnBinding, EntityBindingColumns } from "../metadata/BaseEntityRecordBinding";
import { EntityFieldAccessor } from "./EntityFieldAccessor";

export class EntityTableHelper {
    public static readonly MAX_VIEW_NAME_LENGTH = 30;
    public static readonly MAX_DESCRIPTION_NAME_LENGTH = 500;

    public static MergeFilters(filter1?: Filter, filter2?: Filter | null): Filter {
        if (!filter2 && !filter1) {
            return {} as Filter;
        }
        if (!filter1 && filter2) {
            return filter2;
        }
        if (!filter2 && filter1) {
            return filter1;
        }
        const parts = filter1?.parts || [];
        parts.push(...(filter2?.parts || []));
        return { where: this.MergeWheres(filter1?.where, filter2?.where), parts } as Filter;
    }
    public static MergeWheres(where1: Where | null | undefined, where2: Where | null | undefined): Where {
        const where1Exists = where1 && Object.keys(where1).length > 0;
        const where2Exists = where2 && Object.keys(where2).length > 0;
        if (!where1Exists && !where2Exists) {
            return {} as Where;
        }
        if (where1Exists && !where2Exists) {
            return where1;
        }
        if (!where1Exists && where2Exists) {
            return where2;
        }
        const where = _.cloneDeep(where1) as Where;
        if (Array.isArray(where.AND)) {
            where.AND.unshift(where2 as Where);
        } else {
            where.AND = [where2 as Where];
        }
        return where;
    }
    public static toGridColumn = (col: BaseColumnBinding) => {
        return {
            field: col.fieldName,
            headerName: col.label,
            type: col.contentType.toLowerCase() === "checkbox" ? "boolean" : col.contentType.toLowerCase(),
        } as any;
    };

    public static fromExtendedRecord = <T>(property: (object: T) => void, columns: EntityBindingColumns<any>) => {
        const accessor = new EntityFieldAccessor<T>();
        const { propertyPath, column } = accessor.getFieldPath(property);
        if (!propertyPath || !column) {
            return null;
        }
        const binding = columns[column];
        if (!binding) {
            return null;
        }
        return {
            field: propertyPath,
            headerName: binding.label,
            type: binding.contentType.toLowerCase(),
            valueGetter: (params: any) => _.get(params.row, propertyPath),
        } as any;
    };
    public static fromRelatedProperty(prop: string, header: string) {
        return {
            field: prop,
            headerName: header,
            valueGetter: (params: any) => {
                return _.get(params.row, prop);
            },
        } as any;
    }
}
